import { render } from "./NinthComponent.vue?vue&type=template&id=6c3736b2&scoped=true"
import script from "./NinthComponent.vue?vue&type=script&lang=js"
export * from "./NinthComponent.vue?vue&type=script&lang=js"

import "./NinthComponent.vue?vue&type=style&index=0&id=6c3736b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3736b2"]])

export default __exports__